import { NavLink } from 'react-router-dom';
import { ArrowRight, User2Icon } from 'lucide-react';
import './profile.scss';
import { useEffect, useState } from 'react';
import { getBilling, getOrderAnalytics, } from '../../api/requests';
import { billingData, OrderAnalytics } from '../../interface/interfaces';
import SkeletonLoader from '../SkeletonLoaders/DefaultLoader';
import { useUser } from '../../context/UserContext';
import ProfileOrders from '../ProfileOrders/ProfileOrders';
import 'animate.css'


const Profile = () => {
    const { currentUser } = useUser()

    type pageDataProps = {
        billingData: billingData[],
        analyticsData: OrderAnalytics,
        isLoading: boolean,

    }

    const [pageData, setPageData] = useState<pageDataProps>({
      billingData: [],
      isLoading: false,
      analyticsData: {
        ongoing_orders: 0,
        delivered_orders: 0,
        total_orders: 0,
      },
    });

    const [billing, setBilling] = useState<billingData | null>(null)

    const setPageLoader = (value: boolean) => {
        setPageData((prev) => {
            return {
                ...prev,
                isLoading: value
            }
        })
    }

    useEffect(() => {


        const func = async () => {

            try {
                setPageLoader(true)


                const [billingData, analyticsData] = await Promise.all([getBilling(), getOrderAnalytics()])

                // let billingData = await getBilling()


                setPageData((prev) => {
                    return {
                        ...prev,
                        billingData: billingData,
                        analyticsData:analyticsData
                    }
                })

                setBilling(billingData[0])

            } catch (error) {
                console.error(error)
            } finally {
                setPageLoader(false)
            }

        }

        func()
    }, [])


    return (

        <>

            {pageData.isLoading && (<SkeletonLoader count={4}></SkeletonLoader>)}

            {!pageData.isLoading && (
                <div className="profile animate__animated animate__fadeIn animate__fast">

                    <div className='title'>Hello, {currentUser?.first_name}</div>

                    <div className='text'>
                        From your account dashboard. you can easily check & view your <span className='link'><NavLink to={'/account/orders'}>Recent Orders</NavLink></span>, manage your <span className='link'><NavLink to={'/account/address'}>Shipping and Billing Addresses</NavLink></span> and edit your <span className='link'><NavLink to={'/account/settings'}>Password</NavLink></span> and <span className='link'><NavLink to={'/account/settings'}>Account Details</NavLink></span>
                    </div>

                    <div className='threegrid'>


                        <div className='eachdisp one'>

                            <div className='iconbox'>
                                <div className='icon rocket'></div>
                            </div>

                            <div className='inf'>
                                <div className='num'>{pageData.analyticsData.total_orders}</div>
                                <div className='vtx'>Total Orders</div>
                            </div>
                        </div>

                        <div className='eachdisp two'>
                            <div className='iconbox'>
                                <div className='icon receipt'></div>
                            </div>

                            <div className='inf'>
                                <div className='num'>{pageData.analyticsData.ongoing_orders}</div>
                                <div className='vtx'>Pending Orders</div>
                            </div>
                        </div>


                        <div className='eachdisp three'>
                            <div className='iconbox'>
                                <div className='icon package'></div>
                            </div>

                            <div className='inf'>
                                <div className='num'>{pageData.analyticsData.delivered_orders}</div>
                                <div className='vtx'>Completed Orders</div>
                            </div>
                        </div>


                    </div>


                    <div className='infogrid'>

                        {currentUser && (
                            <div className='eachinfobox'>
                                <div className='infotitle'>Account Info</div>


                                <div className='fdet'>

                                    <div className='detailflex'>

                                        <div className='picbox'>
                                            {currentUser.image && (<div className='profileimage' style={{ backgroundImage: `url(${currentUser.image})` }}></div>)}
                                            {!currentUser.image && (<User2Icon size={25} color='var(--primary)' strokeWidth={1.6}></User2Icon>)}

                                        </div>

                                        <div className='sidetwo'>
                                            <div className='name'>{currentUser.first_name} {currentUser.last_name}</div>
                                            <div className='address'>{currentUser.location}</div>
                                        </div>

                                    </div>


                                    <div className='tpack'>

                                        <div className='eacht'>
                                            <div className='key'>Email:</div>
                                            <span className='value'>{currentUser.email}</span>
                                        </div>

                                        <div className='eacht'>
                                            <div className='key'>Phone:</div>
                                            <span className='value'>{currentUser.phone_number}</span>
                                        </div>

                                    </div>


                                    <NavLink to={'/account/settings'}>
                                        <div className='btn-pack'>
                                            <div className='btn'>Edit Account</div>
                                        </div>
                                    </NavLink>


                                </div>




                            </div>
                        )}





                        {pageData.billingData.length >= 1 && (
                            <div className='eachinfobox'>
                                <div className='infotitle'>Billing address</div>


                                <div className='fdet'>

                                    <div className='ctitle'>{billing?.name}</div>

                                    <div className='ctext'>{billing?.billing_address}</div>


                                    <div className='tpack'>

                                        <div className='eacht'>
                                            <div className='key'>Phone Number:</div>
                                            <span className='value'>{billing?.billing_phone}</span>
                                        </div>

                                        {/* <div className='eacht'>
                            <div className='key'>Email:</div>
                            <span className='value'> kevin.gilbert@gmail.com</span>
                        </div> */}

                                    </div>


                                    <NavLink to={'/account/address'}>
                                        <div className='btn-pack'>
                                            <div className='btn'>Edit Address</div>
                                        </div>
                                    </NavLink>


                                </div>




                            </div>
                        )}





                    </div>


                    <div className='ordersbox'>


                        <div className='upside'>

                            <div className='ctitle'>Recent Order</div>

                            <NavLink to={'/account/orders'}>
                                <div className='flc'>
                                    <span className='viewbtn'>View All</span>
                                    <ArrowRight size={18} color='rgba(3, 57, 248, 1)'></ArrowRight>
                                </div>
                            </NavLink>

                        </div>


                        <ProfileOrders num={3}></ProfileOrders>



                    </div>
                </div>
            )}

        </>

    )
}

export default Profile;